import React, { useEffect, useRef, useState } from "react";
import { formatMoney } from "../../../../utils/formatNumber";
import { Product } from "../../interfaces/ProductsRequest";
import Button from "../../../primitives/Button";
import Image from "../../../Common/Image";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CardV1 = ({
  id,
  name,
  description,
  sub_category_id,
  brand_id,
  is_inventoriable,
  is_presentations,
  variations,
  images,
  promotion,
  sub_category,
  config,
  ImageProvider,
}: Product) => {
  const settings = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    autoplaySpeed: 2000,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <></>,
    prevArrow: <></>,
  };
  const ref = useRef<HTMLDivElement>(null);

  const [width, setWeigth] = useState(392);
  useEffect(() => {
    const width = ref?.current?.clientWidth;
    if (width) setWeigth(width);
  }, [ref]);

  return (
    <div
      ref={ref}
      id="CardV1Container"
      className={`grid relative bg-white rounded-[--border-radius]  px-4 py-4 ${
        config?.shadow && "shadow-lg"
      }
      `}
    >
      <div id="CardV1ContainerImage" className={`cursor-pointer relative`}>
        <div style={{ width: width - 32 }}>
          {images.length > 1 ? (
            <Slider {...settings}>
              {images.map((item) => (
                <Image
                  key={item.image}
                  className="w-full rounded-[--border-radius]"
                  desktop={item.image || ""}
                  alt=""
                  id="CardV1Image"
                  ImageProvider={ImageProvider}
                  height={"auto"}
                  width={"100%"}
                />
              ))}
            </Slider>
          ) : (
            <Image
              className="w-full rounded-[--border-radius]"
              desktop={images?.[0]?.image || ""}
              alt=""
              id="CardV1Image"
              ImageProvider={ImageProvider}
              height={"auto"}
              width={"100%"}
            />
          )}

          {/* <img
          id="CardV1Image"
          src={images?.[0]?.image || ""}
          className="rounded-[--border-radius]"
        ></img> */}
        </div>
      </div>

      {config?.name && (
        <h4
          id="CardV1Name"
          className="text-xl font-semibold text-center cursor-pointer text-gray-800 hover:text-primary-600 mt-2"
        >
          {name}
        </h4>
      )}
      {config?.description && (
        <p id="CardV1Description" className="mt-1 text-center">
          {description}
        </p>
      )}

      {config?.price && (
        <h4
          id="CardV1Price"
          className="text-center text-2xl font-semibold  text-primary-900 mt-1"
        >
          $ {formatMoney(variations?.[0]?.price_sale || 0)}
        </h4>
      )}
      {config?.hasButton && (
        <Button
          {...config?.button}
          className="flex justify-center mt-3 h-16"
          id="CardV1"
        />
      )}
    </div>
  );
};

export default CardV1;
